export default "__VITE_ASSET__CGuWHliM__"